<div class="content">
    <div class="title"
         data-automation-e2e-selector="title">
        Equities
    </div>
    <div class="none"
        *ngIf="(data | async).length === 0">
        No data available
    </div>
    <div id="itemListWrapperId"
         class="itemListWrapper"
         *ngIf="(data | async).length > 0">
        <ul id="itemListId"
            class="itemList"
            data-automation-e2e-selector="itemsList">
            <li *ngFor="let item of data | async; let id = index">
                <muni-gameday-radio-item
                    data-automation-e2e-selector="radioItem"
                    *ngIf="live | async"
                    [id]="'markets-' + id"
                    [shortcut]="'markets'"
                    [selected]="item.displayName == (selected | async)?.displayName"
                    (click)="marketChanged(item)"
                    [attr.data-automation-item-state]="item.displayName == (selected | async)?.displayName ? 'checked' : 'unchecked'">
                    <muni-gameday-market-ticker [market]="item">
                    </muni-gameday-market-ticker>
                </muni-gameday-radio-item>
                <muni-gameday-market-ticker
                    data-automation-e2e-selector="radioItem"
                    *ngIf="!(live | async)"
                    [market]="item">
                </muni-gameday-market-ticker>
            </li>
        </ul>
    </div>
    <div class="disclaimer"
         data-automation-e2e-selector="disclaimer"
        *ngIf="(data | async).length > 0">
        Delayed 15 Minutes
    </div>
</div>
